export default serverAddress => {
  const splitted = serverAddress.split(':');
  const port = splitted.pop();
  return [splitted.join(':'), port];
};
